import React, { Dispatch, SetStateAction } from 'react'
import BGModal from  '../../assets/modalBG.svg'
import btnDeleted from  '../../assets/btnDeleted.svg'

type BeneficiaryAction = 'delete' | 'update' | 'service' | null
interface Props{
    
    setAction:Dispatch<SetStateAction<BeneficiaryAction> >
    HandleDelete: ()=>void
    
}

const ModalDeleteBeneficiary: React.FC <Props> = ({ setAction, HandleDelete}) => {

  return (
    <div
      className=' flex flex-col fixed justify-center place-items-center z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full'>

          <img
            className=" w-24 h-24 -mb-[30px] object-cover rounded-full shadow-xl border-white border-[5px]"
            src={btnDeleted}
            alt="Person Image"
          />
          <img className='relative' src={BGModal} width={327} height={78} alt=''/>
      <div className=' w-[327px] rounded-b-[16px] px-5 pb-5 flex flex-col gap-4 shadow-[0px_4px_10px, rgba(0,0,0,0.25)] bg-white '>

        <h2 className='h3 text-center'>Confirmez-vous la suppression</h2>
        <div className='text-[#6B7280] text-[12px] text-center'>
          Si vous confirmez, votre bénéficiaire sera <br/> définitivement effacé.
        </div>
        <div className='flex w-full gap-4'>
          <button type='button' 
            onClick={() => setAction(null)}
            className=' bg-[#5754E5] hover:bg-[#4D36CC] text-white font-bold rounded-[16px] h-[56px] px-5'>
              Annuler
          </button>

          <button type='button' 
            onClick={() => HandleDelete()}
            className='bg-[#EE443F]/95 hover:bg-[#EE443F] w-full  text-white font-bold rounded-[16px] h-[56px] px-5'>
              Supprimer
          </button>

        </div>
      
      </div>
      </div>
    
  )
}

export default ModalDeleteBeneficiary
